import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

interface ProgressProps extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
    indicatorColor?: string;
    rootColor?: string;
}

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({
    className,
    indicatorColor = "bg-primary",
    rootColor = "gray-200",
    value,
    ...props
}, ref) => (
    <ProgressPrimitive.Root
        ref={ref}
        className={generateValidClassNameHandler(
            `relative h-4 w-full overflow-hidden rounded-full bg-${rootColor}`,
            className,
        )}
        {...props}
    >
        <ProgressPrimitive.Indicator
            className={`size-full flex-1 ${indicatorColor} transition-all`}
            style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
    </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
